import React, { useEffect, useState } from 'react';
import { isMobileDevice, getTime } from '../../../common/utilities/utils';
import { ButtonComp } from 'atoms/Buttons';
import ModalComp from './saveOrderModel';
import Tick from '../../../styles/staticAssets/images/SaveNotifyTick.png';
import PAYMENT_PROCESS from '../Constants';
import MapModal from '../../../organisms/FooterComponent/Presentation/LookupMap';
import BillDescription from './BillDescription';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

import { toast } from 'react-toastify';
import { DeliveryToggle, PickupAndDineInToggle, saveClick, Saved, getDirectionClick } from './orderReceivedScreenFn';
const horizontalLine = (notifySaved, userParams) => {
  return !notifySaved && userParams.loggedIn && <div className='linebreak'></div>;
};
const OrderReceivedScreen = ({ orderReducerData = {}, userParams = {}, tenantReducer = {} }) => {
  const [openModal, toggleModal] = useState(false);
  const [notifySaved, setNotifySaved] = useState(false);

  const [isMobile, setMobileFooter] = useState(isMobileDevice(window.innerWidth));

  const [showMap, setShowMap] = useState(false);

  const [service, setService] = useState('');
  const [time, setTime] = useState('');
  const {
    SAVE_YOUR_ORDERS_AND_CHECKOUT_FASTER = '',
    SAVED_TO_FAVORITE_MENU = '',
    SAVE_THIS_Order = '',
  } = PAYMENT_PROCESS;

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileFooter(isMobileView);
  };

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  useEffect(() => {
    if (notifySaved) {
      toast.dark(
        <div className='img-text-div'>
          <span className={`notifyText notifyText-in`}>
            <img src={Tick} alt='tick' className='TickImg' />
            {translateWithI18Next(SAVED_TO_FAVORITE_MENU)}
          </span>
        </div>,
        {
          bodyClassName: 'toast-for-favorite',
          hideProgressBar: true,
          position: toast.POSITION.BOTTOM_CENTER,
        },
      );
      setTimeout(() => {
        toast.dismiss();
      }, 4000);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifySaved]);

  const getDirectionClickForMaps = () => {
    getDirectionClick(setShowMap);
  };

  const billDescriptionView = () => {
    return (
      <BillDescription
        orderReducerData={orderReducerData}
        tenantReducer={tenantReducer}
        getDirectionClickForMaps={getDirectionClickForMaps}
      />
    );
  };

  useEffect(() => {
    if (orderReducerData.id) {
      setService(orderReducerData.service);
      const val = orderReducerData.fulfillmentDateTime;
      const timer = getTime(val);
      setTime(timer);
    }
  }, [orderReducerData]);

  return (
    <div>
      <div className='OrderReceivedContainer'>
        <div className='content'>
          <div className='NotifyOrderPlaced'>
            <div className='tickimage'>
              {service.toUpperCase() === 'DELIVERY' ? (
                <div>{DeliveryToggle(orderReducerData, time)}</div>
              ) : (
                <div>{PickupAndDineInToggle(orderReducerData, time, service)}</div>
              )}
              {horizontalLine(notifySaved, userParams)}
              {userParams.loggedIn && (
                <div>
                  {!notifySaved && (
                    <div className='savingdiv'>
                      <span className='saving'>{translateWithI18Next(SAVE_YOUR_ORDERS_AND_CHECKOUT_FASTER)}</span>
                      <span className='saveButton'>
                        <ButtonComp
                          data-testid='save-logged-order'
                          className='button transparent-btn black-border'
                          onClick={() => saveClick(toggleModal)}
                          ariaLable={translateWithI18Next(SAVE_THIS_Order)}
                        >
                          {translateWithI18Next(SAVE_THIS_Order)}
                        </ButtonComp>
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          {billDescriptionView()}
        </div>
      </div>
      {openModal && (
        <div>
          <ModalComp
            data-testid='confirm-modal'
            isOpen={openModal}
            handleClose={() => toggleModal(false)}
            onSave={() => Saved(setNotifySaved, true)}
            tenantReducer={tenantReducer}
            OrderReducerData={orderReducerData}
          />
        </div>
      )}
      {showMap && (
        <div>
          <MapModal
            data-testid='map-modal'
            isOpen={showMap}
            handleClose={() => setShowMap(false)}
            OrderReducerData={orderReducerData}
          />
        </div>
      )}
    </div>
  );
};
export default OrderReceivedScreen;
